var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    ref: "turnstile",
    staticClass: "d-inline-block captcha-component captcha-turnstile",
    class: { "border-error error-anchor": !_vm.validResponse },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }